import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['contentDisplay'];

  toggleContent(event) {
    const value = String(event.target.value);
    const shouldShow = value === 'true';
    this.contentDisplayTarget.classList.toggle('d-none', !shouldShow);
  }
}
